export default __webpack_public_path__ + "static/media/Group 35.34805061.svg";